// services/carCodeMap.js
import axios from "axios";
import * as auth from "./auth";

// общий инстанс с куками
const api = axios.create({
  withCredentials: true,
});

// проставляем Bearer из куки на каждый запрос
api.interceptors.request.use((config) => {
  const token = auth.getCookie?.();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// хелпер: если FormData — ставим multipart
function withContentType(payload, baseConfig = {}) {
  const cfg = { ...baseConfig };
  if (typeof FormData !== "undefined" && payload instanceof FormData) {
    cfg.headers = { ...(cfg.headers || {}), "Content-Type": "multipart/form-data" };
  }
  return cfg;
}

export async function index(params = {}) {
  const { q = "", is_active = "", page = 1, per_page = 50 } = params;
  try {
    const { data } = await api.get("/api/admin/article/car-code-map", {
      params: { q, is_active, page, per_page },
    });
    return data;
  } catch (exception) {
    return exception.response;
  }
}

export async function store(payload) {
  try {
    const { data } = await api.post(
      "/api/admin/article/car-code-map",
      payload,
      withContentType(payload)
    );
    return data;
  } catch (exception) {
    return exception.response;
  }
}

export async function update(id, payload) {
  try {
    const { data } = await api.put(
      `/api/admin/article/car-code-map/${id}`,
      payload,
      withContentType(payload)
    );
    return data;
  } catch (exception) {
    return exception.response;
  }
}

export async function destroy(id) {
  try {
    const { data } = await api.delete(`/api/admin/article/car-code-map/${id}`);
    return data;
  } catch (exception) {
    return exception.response;
  }
}

export async function upsertMany(items) {
  // items может быть обычным объектом (JSON)
  try {
    const { data } = await api.post(
      "/api/admin/article/car-code-map/upsert-many",
      { items }
    );
    return data;
  } catch (exception) {
    return exception.response;
  }
}

export async function rebuildCache() {
  try {
    const { data } = await api.post("/api/admin/article/car-code-map/rebuild-cache");
    return data;
  } catch (exception) {
    return exception.response;
  }
}
